import React from "react";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "../styles.css";

// Ссылка-иконка «просмотр» (глаз) на карточку записи из строки списка.
export default function ButtonLinkShow({ href, title = 'Просмотр', className = '', ...other }) {
    if (!href) return null;
    return <Link {...other} to={href} title={title} className={`button-link ${className}`}>
        <VisibilityIcon fontSize="small"/>
    </Link>;
}
